export function camelCaseToHyphen(text) {
    return text.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`);
}

export default null;
